import { requestExtraPickupData } from "constants-lib/seo/requestExtraPickupData"
import { addJSONLDToHead, removeElement } from "./jsonLD.js"

export const getRequestExtraPickup = (schemaData) => {
  const data = schemaData.map((item) => ({
    "@type": `Question`,
    name: item.Question,
    acceptedAnswer: {
      "@type": `Answer`,
      text: item.Answer,
    },
  }))
  return data
}

/* Add Request Extra Pickup JSON LD if needed, otherwise make sure it does not exist in Head. */
export const addRequestExtraPickup = () => {
  if (
    window.location.href.includes(
      `/us/en/support/faqs/how-do-i-connect-with-you-quickly-to-request-an-extra-pickup`,
    ) &&
    document.getElementById(`requestExtraPickup`) === null
  ) {
    const script = requestExtraPickupJSONLD()
    addJSONLDToHead(script, `requestExtraPickup`)
  } else {
    removeElement(`requestExtraPickup`)
  }
}

// JSON LD template for Request Extra Pickup
const requestExtraPickupJSONLD = () => {
  const requestExtraPickupTemplate = {
    "@context": `http://schema.org`,
    "@type": `FAQPage`,
    mainEntity: getRequestExtraPickup(requestExtraPickupData),
  }
  return requestExtraPickupTemplate
}
